@if (currentTip) {
  <div
    class="tips"
    animate.enter="animate animate-fade-in"
    animate.leave="animate animate-fade-out"
  >
    <div class="tips-inner">
      <span class="tips-title">Tip:</span>
      {{ currentTip.text }}
      @if (currentTip.link) {
        <div>
          <a [href]="currentTip.link" target="_blank" rel="noopener">
            <app-icon name="info" />
            {{ 'LEARN_MORE_TEXT' | translate }}
          </a>
        </div>
      }
    </div>
  </div>
}
